<template>
  <SocialMarketingCardContainer :inProgress="inProgress" size="story">
    <SocialMarketingImage
      class="flex-1"
      :userImage="marketingAsset.image"
      :gradient="backgroundGradient"
      :editMode="editMode"
    >
      <div class="card-p-3 flex-1">
        <SocialMarketingStudioInfo
          class="card-mb-3"
          color="light"
          :showProfilePhoto="false"
        />
      </div>
      <div class="card-p-3 flex-1 d-flex flex-column">
        <div class="flex-1">
          <SocialMarketingStudioContent
            :title="marketingAsset.title"
            :description="marketingAsset.description"
            :descriptionMaxLines="13"
            colorType="light"
          />
        </div>
        <SocialMarketingStudioInfo
          class="card-mt-3"
          color="light"
          :studioUrl="studioUrl"
          :showMarvelousIcon="false"
        />
      </div>
    </SocialMarketingImage>
  </SocialMarketingCardContainer>
</template>

<script>
import SocialMarketingCardContainer from '@/web/components/marketing/SocialMarketingCardContainer.vue';
import SocialMarketingStudioInfo from '@/web/components/marketing/SocialMarketingStudioInfo.vue';
import SocialMarketingStudioContent from '@/web/components/marketing/SocialMarketingStudioContent.vue';
import SocialMarketingImage from '@/web/components/marketing/SocialMarketingImage.vue';

export default {
  name: 'Template9',
  components: {
    SocialMarketingCardContainer,
    SocialMarketingStudioInfo,
    SocialMarketingStudioContent,
    SocialMarketingImage,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    inProgress: {
      type: Boolean,
      default: false,
    },
    isDownload: {
      type: Boolean,
      default: false,
    },
    studioUrl: {
      type: String,
      default: '',
    },
    profilePhoto: {
      type: String,
      default: '',
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      backgroundGradient:
        'linear-gradient(360deg, rgba(16, 22, 24, 0.80) 0%, rgba(16, 22, 24, 0.00) 100%)',
    };
  },
  computed: {
    marketingAsset() {
      return this.value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
